import  styles from"./QuickMenu.css";
import React, { Dispatch, ReactElement, useEffect, useRef, useState } from "react";
import useFade from "../../hooks/useFade";
import WaveShow from "../WaveShow/waveshow";
import AnimateComponent from "../WaveShow/animatecomponent";
import EagleILogo from "../../assets/Eagle_I_Logo.png";
import RoundMenu from "./RoundMenu";
import { updateMapCenter, updateMapZoom } from "../../mainLayer/MainLayer";
import { ThemeProvider, useTheme } from "../../theme/ThemeContext";
import AirSharpIcon from '@mui/icons-material/AirSharp';
import DeviceThermostatSharpIcon from '@mui/icons-material/DeviceThermostatSharp';
import FloodIcon from '@mui/icons-material/Flood';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import WavesIcon from '@mui/icons-material/Waves';
import Co2Icon from '@mui/icons-material/Co2';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import TireRepairIcon from '@mui/icons-material/TireRepair';

interface SlideData {
  id: number;
  bgColor: string;
  image: React.ReactNode;
  icon: React.ReactNode;
  title: string;
  desc: string;
}

interface QuickMenuProps {
  data: SlideData[];
  activeSlide: number;
  voiceRecognitionValue: (value: string) => void;
  openConsole: (value: boolean) => void;
  setVoiceCommand: Dispatch<React.SetStateAction<string>>
}

const QuickMenu: React.FC<QuickMenuProps> = (props) => {
  const [isVisible, setVisible, fadeProps] = useFade(false);
  const [activeSlide, setActiveSlide] = useState(props.activeSlide);
  const [dragStartX, setDragStartX] = useState<number | null>(null);
  const slideRef = useRef<HTMLDivElement>(null);
  const [value, setValue] = useState<string>("");
  const { theme } = useTheme();
  const handleButtonClick = (value: string) => {
    setValue(value);

    if (value === "ClickedImage") {
      setVisible(!isVisible);
    }
  };

  const next = () =>
    setActiveSlide((prevActiveSlide) =>
      prevActiveSlide < props.data.length - 1 ? prevActiveSlide + 1 : 0
    );

  const prev = () =>
    setActiveSlide((prevActiveSlide) =>
      prevActiveSlide > 0 ? prevActiveSlide - 1 : props.data.length - 1
    );

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    setDragStartX(event.clientX);
  };

  const handleMouseUp = () => {
    setDragStartX(null);
  };

  const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
    if (dragStartX !== null && slideRef.current) {
      const deltaX = event.clientX - dragStartX;
      const threshold = 100;
      if (deltaX > threshold) {
        prev();
        setDragStartX(null);
      } else if (deltaX < -threshold) {
        next();
        setDragStartX(null);
      }
    }
  };

  const getStyles = (index: number) => {
    if (activeSlide === index) {
      return {
        opacity: 1,
        transform: "translateX(0px) translateZ(0px) rotateY(0deg)",
        zIndex: 10,
        top: "0px",
      };
    } else if (activeSlide - 1 === index) {
      return {
        opacity: 1,
        transform: "translateX(-90px) translateZ(-500px) rotateY(35deg)",
        zIndex: 9,
        top: "-10px",
      };
    } else if (activeSlide + 1 === index) {
      return {
        opacity: 1,
        transform: "translateX(90px) translateZ(-500px) rotateY(-35deg)",
        zIndex: 9,
        top: "-10px",
      };
    } else if (activeSlide - 2 === index) {
      return {
        opacity: 1,
        transform: "translateX(-140px) translateZ(-500px) rotateY(35deg)",
        zIndex: 8,
        top: "20px",
      };
    } else if (activeSlide + 2 === index) {
      return {
        opacity: 1,
        transform: "translateX(140px) translateZ(-500px) rotateY(-35deg)",
        zIndex: 8,
        top: "20px",
      };
    }
    //0000000
    else if (activeSlide - 3 === index) {
      return {
        opacity: 1,
        transform: "translateX(-180px) translateZ(-500px) rotateY(35deg)",
        zIndex: 7,
        top: "60px",
      };
    } else if (activeSlide + 3 === index) {
      return {
        opacity: 1,
        transform: "translateX(180px) translateZ(-500px) rotateY(-35deg)",
        zIndex: 7,
        top: "60px",
      };
    }
    //00000
    else if (activeSlide - 4 === index) {
      return {
        opacity: 1,
        transform: "translateX(-210px) translateZ(-500px) rotateY(35deg)",
        zIndex: 6,
        top: "110px",
        //marginLeft: "60px"
      };
    } else if (activeSlide + 4 === index) {
      return {
        opacity: 1,
        transform: "translateX(210px) translateZ(-500px) rotateY(-35deg)",
        zIndex: 6,
        top: "110px",
        //marginLeft: "-60px"
      };
    } else if (activeSlide - 5 === index) {
      return {
        opacity: 0,
        transform: "translateX(-230px) translateZ(-500px) rotateY(35deg)",
        zIndex: 6,
        top: "270px",
        //marginLeft: "60px"
      };
    } else if (activeSlide + 5 === index) {
      return {
        opacity: 0,
        transform: "translateX(230px) translateZ(-500px) rotateY(-35deg)",
        zIndex: 6,
        top: "270px",
        //marginLeft: "-60px"
      };
    } else if (index < activeSlide - 5) {
      var x = 250;
      var y = 240;
      var z = 80;
      var a = 20;
      for (var i = 6; i < props.data.length; i++) {
        if (i >= props.data.length - 5) {
          z = z - 10;
          x = x - a;
          a = a + 6;
          y = y - z;
          if (index === activeSlide - i) {
            if (activeSlide - (props.data.length - 5) === index) {
              return {
                opacity: 0,
                transform:
                  "translateX(230px) translateZ(-500px) rotateY(-35deg)",
                zIndex: 6,
                top: "270px",
                //marginLeft: "-60px"
              };
            } else {
              return {
                opacity: 1,
                transform: `translateX(${x}px) translateZ(-500px) rotateY(-35deg)`,
                top: `${y}px`,
                zIndex: 6,
              };
            }
          }
        } else {
          if (index === activeSlide - i) {
            return {
              opacity: 0,
              transform: "translateX(230px) translateZ(-500px) rotateY(-35deg)",
              zIndex: 6,
              top: "270px",
            };
          }
        }
      }
    } else if (index > activeSlide + 5) {
      var p = 250;
      var q = 240;
      var r = 80;
      var s = 20;
      for (var j = 6; j < props.data.length; j++) {
        if (j >= props.data.length - 5) {
          r = r - 10;
          p = p - s;
          s = s + 6;
          q = q - r;
          if (index === activeSlide + j) {
            if (activeSlide + (props.data.length - 5) === index) {
              return {
                opacity: 0,
                transform:
                  "translateX(-230px) translateZ(-500px) rotateY(35deg)",
                zIndex: 6,
                top: "270px",
                //marginLeft: "60px"
              };
            } else {
              return {
                opacity: 1,
                transform: `translateX(-${p}px) translateZ(-500px) rotateY(35deg)`,
                top: `${q}px`,
                zIndex: 6,
              };
            }
          }
        } else {
          if (index === activeSlide + j) {
            return {
              opacity: 0,
              transform: "translateX(-230px) translateZ(-500px) rotateY(35deg)",
              zIndex: 6,
              top: "270px",
            };
          }
        }
      }
    }
  };

  type MenuItemType = {
    text: string;
    bgImage: ReactElement<any, any>;
  };

  const menuItems: Array<MenuItemType> = [
    {
      text: 'Wind',
      bgImage: <AirSharpIcon className={`roundMenuIco ${theme}`} />,
    },
    {
      text: 'Temperature',
      bgImage: <DeviceThermostatSharpIcon className={`roundMenuIco ${theme}`} />,
    },
    {
      text: 'Accumulated Rain',
      bgImage: <ThunderstormIcon className={`roundMenuIco ${theme}`} />,
    },
    {
      text: 'Air pressure',
      bgImage: <TireRepairIcon className={`roundMenuIco ${theme}`} />,
    },
    {
      text: 'Flood',
      bgImage: <FloodIcon className={`roundMenuIco ${theme}`}  />,
    },
    {
      text: 'Early Warning',
      bgImage: <ErrorIcon className={`roundMenuIco ${theme}`}  />,
    },
    {
      text: 'Reported Incidents',
      bgImage: <WarningIcon className={`roundMenuIco ${theme}`} />,
    },
    
    {
      text: 'River Sensors',
      bgImage: <WavesIcon className={`roundMenuIco ${theme}`}  />,
    },
    {
      text: 'Air Quality',
      bgImage: <Co2Icon className={`roundMenuIco ${theme}`} />,
    }, {
      text: 'Satellites',
      bgImage: <SatelliteAltIcon className={`${styles.roundMenuIco}`}  />,
    }
  ]

  return (
    <div
      className="quickMenu-container"
      style={{
        width: "400px",
        height: "100%",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <RoundMenu
        circleRedious={50}
        menuItemWidth={60}
        menuItemHeight={60}
        itemCount={9}
        offset={70}
        selectScale={1.5}
        leftArrow={require("../../assets/play.png")}
        rightArrow={require("../../assets/pause.png")}
        circleBg={require("../../assets/earth.png")}
        itemData={menuItems}     voiceRecognitionValue={props.voiceRecognitionValue}  // Pass the prop down
        openConsole={props.openConsole} 
                // New
                setVoiceCommand={props.setVoiceCommand}
      />
    </div>
  );
};

const SliderContent: React.FC<SlideData> = (props) => {
  return <div className="sliderContent">{props.image}</div>;
};

export default QuickMenu;
